import React, { useEffect, useState } from "react";
import { api, fmtDateTime } from "../lib/api";
import { PageHeader, Surface } from "../components/Primitives";

export default function Audit() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setList(r.data)); }, []);

  return (
    <div>
      <PageHeader overline="Admin" title="Audit log"
        subtitle="Immutable record of changes — who did what, when." />
      <div className="p-8">
        <Surface>
          <table className="w-full text-sm">
            <thead className="border-b border-zinc-800 text-[10px] uppercase tracking-wider text-zinc-500 font-mono">
              <tr><th className="text-left py-3 px-4">Timestamp</th><th className="text-left py-3 px-4">User</th><th className="text-left py-3 px-4">Action</th><th className="text-left py-3 px-4">Target</th></tr>
            </thead>
            <tbody data-testid="audit-table">
              {list.length === 0 && <tr><td colSpan={4} className="py-12 text-center text-zinc-500">No audit entries.</td></tr>}
              {list.map((a) => (
                <tr key={a.id} className="border-b border-zinc-900">
                  <td className="py-2.5 px-4 font-mono text-zinc-400 text-xs">{fmtDateTime(a.timestamp)}</td>
                  <td className="py-2.5 px-4">{a.user_name}</td>
                  <td className="py-2.5 px-4 font-mono text-amber text-xs uppercase tracking-wider">{a.action}</td>
                  <td className="py-2.5 px-4 font-mono text-zinc-400 text-xs truncate max-w-md">{a.target}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Surface>
      </div>
    </div>
  );
}
